import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from 'src/app/core/services/date-time.service';

@Pipe({
  name: 'dateConverter',
  standalone: true,
})
export class DateConverterPipe implements PipeTransform {
  transform(dateTime: any, args?: any): any {
    if (!dateTime || !args) return '-';

    if (args === 'fa')
      return DateTimeService.utcToLocalShamsiDate(dateTime) || '-';
    else if (args === 'en-US')
      return DateTimeService.utcToLocalDate(dateTime) || '-';
  }
}
